<template>
  <!-- Info boxes -->
  <section>
    <loading :active.sync="isLoading"
        :can-cancel="true"
        color="#5bad2b"
        :is-full-page="fullPage"></loading>
    <!-- <loading :active.sync="isLoading"></loading> -->
    <div class="row"  style="background-color: #303439;">
      <div class="content">
      <div class="col-md-7">
        <carousel :per-page="1" class="c-slide" :autoplay="true" :autoplayHoverPause="true" :loop="true">
          <slide>
            <div class="row">
              <div class="col-md-9">
                <br>
                <h3 class="mt-2">Hello {{userInfo.organization}} !</h3>
                <p class="mt-2" style="font-size: 16px;">Screenit just don’t promote our application, we work with our partners and progress together.</p>
              </div>
              <div class="col-md-3">
                <img src="../../assets/img/dashboard_welcome.gif" class="pull-right" style="width: 150px;">
              </div>
            </div>
          </slide>
          <slide>
            <div class="row">
              <div class="col-md-9">
                <br>
                <h3 class="mt-2">Hello {{userInfo.organization}} !</h3>
                <p class="mt-2" style="font-size: 16px;">
                  Interview session has been recorded and available in the result module for the future references.</p>
              </div>
              <div class="col-md-3">
                <img src="../../assets/img/gif2.gif" class="pull-right" style="width: 150px;">
              </div>
            </div>
          </slide>
          <slide>
            <div class="row">
              <div class="col-md-9">
                <br>
                <h3 class="mt-2">Hello {{userInfo.organization}} !</h3>
                <p class="mt-2" style="font-size: 16px;">
                    Scheduled Interviews can be rescheduled for unanticipated situation.
                </p>
              </div>
              <div class="col-md-3">
                <img src="../../assets/img/gif3.gif" class="pull-right" style="width: 150px;">
              </div>
            </div>
          </slide>
        </carousel>
      </div>
      <div class="col-md-5" v-if="upcoming_count > 0">
        <div class="row upcoming">
          <div class="col-md-7">
          <div class="box">
            <div class="box-header">
              <h5 class="box-title"><b>Upcoming Interview</b></h5>
            </div>
            <div class="box-body" style="height: auto;">
                <ul class="products-list product-list-in-box mt-2">
                  <li>
                      <div class="product-img">
                        <!-- <img src="../../assets/img/default.png" alt="Product Image"> -->
                        <img @click="showModal(upcoming_Schedule.user_id, upcoming_Schedule.post_id)" v-if="upcoming_Schedule.profile_picture !='' && upcoming_Schedule.profile_picture !=null" :src="`${upcoming_Schedule.profile_picture}`">
                        <img @click="showModal(upcoming_Schedule.user_id, upcoming_Schedule.post_id)" v-if="(upcoming_Schedule.profile_picture =='' || upcoming_Schedule.profile_picture == null) && upcoming_Schedule.gender == null" src="../../assets/img/default.png">
                        <img @click="showModal(upcoming_Schedule.user_id, upcoming_Schedule.post_id)" v-if="(upcoming_Schedule.profile_picture =='' || upcoming_Schedule.profile_picture ==null) && upcoming_Schedule.gender == 'Female'" src="../../assets/img/female_default.png">
                        <img @click="showModal(upcoming_Schedule.user_id, upcoming_Schedule.post_id)" v-if="(upcoming_Schedule.profile_picture =='' || upcoming_Schedule.profile_picture ==null) && upcoming_Schedule.gender == 'Male'" src="../../assets/img/male_default.png">
                      </div>
                      <div class="product-info d1">
                        <a href="javascript:void(0)" @click="showModal(upcoming_Schedule.user_id, upcoming_Schedule.post_id)" class="product-title c-bl">{{upcoming_Schedule.first_name}} {{upcoming_Schedule.last_name}}
                        </a>
                        <span class="product-description">
                            <span class="text-muted">Position</span>
                            <span class="product-title c-b1"> {{upcoming_Schedule.job_tittle}}</span>
                        </span>
                      </div>
                    </li>
                </ul>
            </div>
          </div>
          </div>
          <div class="col-md-5">
            <div class="box">
              <div class="box-header">
                <span class="pull-right arrow-next"><i class="uil uil-arrow-right"></i></span>
                <span class="pull-right arrow-next mr-2"><i class="uil uil-arrow-left"></i></span>
              </div>
              <div class="box-body" style="height: auto;">
                <img src="../../assets/img/upcoming-schedule.svg" style="width: 84px;">
              </div>
            </div>
          </div>
          <div class="col-md-12 upcoming-schedule">
            <div class="col-md-3 p-1">Scheduled on</div>
            <div class="col-md-6 p-1 c-bl product-title">{{ upcoming_Schedule.schedule_date | formatDate }} {{ upcoming_Schedule.start_datetime | time}} - {{ upcoming_Schedule.end_datetime | time}}</div>
            <div class="col-md-3">
              <button :disabled="checkingdate(upcoming_Schedule.start_datetime, upcoming_Schedule.end_datetime) == 'no'" @click="connect(upcoming_Schedule.meeting_id, upcoming_Schedule._id)" v-if="upcoming_Schedule.status == 'Open'" type="button" class="b-radious btn connectbtn btn-sm pull-right">Connect</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-5" v-if="upcoming_count == 0">
        <div class="row upcoming">
          <div class="col-md-7">
          <div class="box" style="min-height: 166px;">
            <div class="box-header">
              <h5 class="box-title"></h5>
            </div>
            <div class="box-body" style="height: auto;">
                <ul class="products-list product-list-in-box mt-2">
                  <li>
                      <div class="d1">
                        <a href="javascript:void(0)" class="product-title" style="color: #5AAE46!important;">
                          <h4><b>We are happy to see you on screenit!</b></h4>
                        </a>
                        <span style="font-size: 12px;">
                            <span class="text-muted">Make your hiring faster and unique with marketplace interviewers</span>
                        </span>
                      </div>
                    </li>
                </ul>
            </div>
          </div>
          </div>
          <div class="col-md-5">
            <div class="box">
              <div class="box-header">
                <!-- <span class="pull-right arrow-next"><i class="uil uil-arrow-right"></i></span>
                <span class="pull-right arrow-next mr-2"><i class="uil uil-arrow-left"></i></span> -->
              </div>
              <div class="box-body pull-right" style="height: auto;margin-top: 20px;">
                <img src="../../assets/img/welcome-icon.svg" style="width: 84px;">
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
    <!-- /.row -->
    <div class="content">
    <div class="row mb-2" style="margin-top:-35px">
      <div class="col-md-3 removeline cursor-p" @click="navigation('Post','no')" v-if="total_post < 1">
        <div class="card mb-3 removeline" tabindex="0">
          <div class="card-header fw-600 p-2">
            <div class="row" style="margin-top: 13%;margin-bottom: 11%;">
              <div class="col-md-1"></div>
              <div class="col-md-3 removeline mt-2"> <img src="../../assets/img/post_new.svg" class="pull-right"></div>
              <div class="col-md-2 removeline"> <h5><strong>Post</strong></h5> </div>
              <div class="col-md-2 removeline mt-2"> <i class="uil uil-arrow-right fa-2x"></i></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 removeline cursor-p" @click="navigation('Post','no')" v-if="total_post > 0">
        <div class="card mb-3 removeline" tabindex="0">
          <div class="card-header fw-600 p-2">
            <div class="row">
              <div class="col-md-8 removeline"> <h5><strong>Post</strong></h5> </div>
              <div class="col-md-4 removeline"> <img src="../../assets/img/post_new.svg" class="pull-right mt-2"></div>
            </div>
          </div>
          <div class="card-body p-2">
            <div class="row">
              <div class="col-md-8 removeline mb-2"> <h4 class="mb-1"><b>{{total_post}}</b></h4> <i class="uil uil-arrow-growth c-orange"></i> <strong>+{{recent_post}}</strong> <span>this week</span></div>
              <div class="col-md-4 removeline p-1"><br> <i class="uil uil-arrow-right fa-2x ml-5 pull-right mr-2" style="background-color: #cccccc24;"></i> </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 removeline cursor-p" @click="navigation('To-be-Scheduled','no')" v-if="total_interest < 1">
        <div class="card mb-3 removeline" tabindex="0">
          <div class="card-header fw-600 p-2">
            <div class="row" style="margin-top: 9%;margin-bottom: 9%;">
              <div class="col-md-1"></div>
              <div class="col-md-3 removeline mt-2"> <img src="../../assets/img/interest_new.svg" class="pull-right"></div>
              <div class="col-md-3 removeline"> <h5><strong>Mutual Interest</strong></h5> </div>
              <div class="col-md-2 removeline mt-2"> <i class="uil uil-arrow-right fa-2x mt-2"></i></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 removeline cursor-p" @click="navigation('To-be-Scheduled','no')" v-if="total_interest > 0">
        <div class="card mb-3 removeline" tabindex="0">
          <div class="card-header removeline fw-600 p-2">
            <div class="row">
              <div class="col-md-8 removeline"> <h5><strong>Mutual Interest</strong></h5> </div>
              <div class="col-md-4 removeline"> <img src="../../assets/img/interest_new.svg" class="pull-right"> </div>
            </div>
          </div>
          <div class="card-body removeline p-2">
            <div class="row">
              <div class="col-md-8 removeline mb-2"> <h4 class="mb-1"><b>{{total_interest}}</b></h4> <i class="uil uil-arrow-growth c-orange"></i> <strong>+{{recent_interest}}</strong> <span>this week</span></div>
              <div class="col-md-4 removeline p-1"><br> <i class="uil uil-arrow-right fa-2x ml-5 pull-right mr-2" style="background-color: #cccccc24;"></i> </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 removeline cursor-p" @click="navigation('Scheduled','no')" v-if="total_schedule < 1">
        <div class="card mb-3 removeline" tabindex="0">
          <div class="card-header fw-600 p-2">
            <div class="row" style="margin-top: 13%;margin-bottom: 11%;">
              <div class="col-md-1"></div>
              <div class="col-md-3 removeline mt-2"> <img src="../../assets/img/schedule_new.svg" class="pull-right"></div>
              <div class="col-md-3 removeline"> <h5><strong>Schedule</strong></h5> </div>
              <div class="col-md-2 removeline mt-2"> <i class="uil uil-arrow-right fa-2x"></i></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 removeline cursor-p" @click="navigation('Scheduled','no')" v-if="total_schedule > 0">
        <div class="card mb-3 removeline" tabindex="0">
          <div class="card-header removeline fw-600 p-2">
            <div class="row">
              <div class="col-md-8 removeline"> <h5><strong>Schedule</strong></h5> </div>
              <div class="col-md-4 removeline"> <img src="../../assets/img/schedule_new.svg" class="pull-right mt-2"></div>
            </div>
          </div>
          <div class="card-body removeline p-2">
            <div class="row">
              <div class="col-md-8 removeline mb-2"> <h4 class="mb-1"><b>{{total_schedule}}</b></h4> <i class="uil uil-arrow-growth c-orange"></i> <strong>+{{recent_schedule}}</strong> <span>this week</span></div>
              <div class="col-md-4 removeline p-1"><br> <i class="uil uil-arrow-right fa-2x ml-5 pull-right mr-2" style="background-color: #cccccc24;"></i> </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 removeline cursor-p" @click="navigation('Result','no')" v-if="total_feedbacks < 1">
        <div class="card mb-3 removeline" tabindex="0">
          <div class="card-header fw-600 p-2">
            <div class="row" style="margin-top: 13%;margin-bottom: 11%;">
              <div class="col-md-1"></div>
              <div class="col-md-3 removeline mt-2"> <img src="../../assets/img/result_new.svg" class="pull-right"></div>
              <div class="col-md-3 removeline"> <h5><strong>Feedback</strong></h5> </div>
              <div class="col-md-2 removeline mt-2"> <i class="uil uil-arrow-right fa-2x"></i></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 removeline cursor-p" @click="navigation('Result','no')" v-if="total_feedbacks > 0">
        <div class="card mb-3 removeline" tabindex="0">
          <div class="card-header removeline fw-600 p-2">
            <div class="row">
              <div class="col-md-8 removeline"> <h5><strong>Feedback</strong></h5> </div>
              <div class="col-md-4 removeline"> <img src="../../assets/img/result_new.svg" class="pull-right mt-2"></div>
            </div>
          </div>
          <div class="card-body removeline p-2">
            <div class="row">
              <div class="col-md-8 removeline mb-2"> <h4 class="mb-1"><b>{{total_feedbacks}}</b></h4> <i class="uil uil-arrow-growth c-orange"></i> <strong>+{{recent_feedbacks}}</strong> <span>this week</span></div>
              <div class="col-md-4 removeline p-1"><br> <i class="uil uil-arrow-right fa-2x ml-5 pull-right mr-2" style="background-color: #cccccc24;"></i> </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" style="margin-top: 24px;">
      <div class="col-md-6">
          <div class="box box-primary radius6" style="height: 325px;">
              <div class="box-header with-border">
                <h3 class="box-title fw-600">Recent Post</h3>
                <div class="box-tools pull-right">
                  <button type="button" class="btn btn-box-tool c-b" @click="navigation('Post','no')"><b>See all</b></button>
                </div>
                <!-- <p style="margin-bottom: 0rem;">You can view your recent RD</p> -->
              </div>
              <!-- /.box-header -->
              <div class="box-body">
                <ul class="products-list product-list-in-box mt-2">
                  <div v-if="dataslength < 1" class="text-muted tc" style="margin-top: 20%;">No data found</div>
                  <li class="item" v-for="(x, index) in datas.slice(0, 3)" :key="index" @click="navigation('Post',x)">
                      <div class="product-img">
                        <!-- <img src="../../assets/img/default.png" alt="Product Image"> -->
                        <img @click="showModal(x._id, x.post_id)" v-if="x.profile_picture !='' && x.profile_picture !=null" :src="`${x.profile_picture}`">
                        <img @click="showModal(x._id, x.post_id)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == null" src="../../assets/img/default.png">
                        <img @click="showModal(x._id, x.post_id)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == 'Female'" src="../../assets/img/female_default.png">
                        <img @click="showModal(x._id, x.post_id)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == 'Male'" src="../../assets/img/male_default.png">
                      </div>
                      <div class="product-info d1">
                        <a href="javascript:void(0)" class="product-title c-bl">{{x.job_tittle}}
                          <span class="text-ago pull-right">{{ x.created_at | timeago }}</span></a>
                        <span class="product-description">
                            <span class="c-v">{{x.post_unique_id}}</span>
                        </span>
                      </div>
                      <div class="product-description bottom-count">
                        <span class="col-md-3 text-muted">Interest<span class="fw-600 c-bl"> {{x.total_interest_count}}</span></span>
                        <span class="col-md-3 text-muted">To-be Schedule<span class="fw-600 c-bl"> {{x.tobeschedule_count}}</span></span>
                        <span class="col-md-3 text-muted">Schedule<span class="fw-600 c-bl"> {{x.schedule_count}}</span></span>
                        <span class="col-md-3 text-muted">Result<span class="fw-600 c-bl"> {{x.result_count}}</span></span>
                      </div>
                    </li>
                  <!-- /.item -->
                </ul>
              </div>
              <!-- /.box-footer -->
            </div>
        </div>
        <div class="col-md-6">
          <div class="box box-primary radius6" style="height: 325px;">
              <div class="box-header with-border">
                <h3 class="box-title fw-600">Recent Interests</h3>
                <div class="box-tools pull-right">
                  <!-- <button type="button" class="btn btn-box-tool c-b">View all</button> -->
                </div>
                <!-- <p style="margin-bottom: 0rem;">You can view your recent RD</p> -->
              </div>
              <!-- /.box-header -->
              <div class="box-body">
                <ul class="products-list product-list-in-box">
                  <div v-if="recent_interest_data_lendth < 1" class="text-muted tc" style="margin-top: 20%;">No data found</div>
                  <li class="item" v-for="(item, index) in recent_interest_data.slice(0, 4)" :key="index">
                      <div class="product-img">
                        <!-- <img src="../../assets/img/default.png" alt="Product Image"> -->
                        <img @click="showModal(item._id, item.post_id)" v-if="item.profile_picture !='' && item.profile_picture !=null" :src="`${item.profile_picture}`">
                        <img @click="showModal(item._id, item.post_id)" v-if="(item.profile_picture =='' || item.profile_picture == null) && item.gender == null" src="../../assets/img/default.png">
                        <img @click="showModal(item._id, item.post_id)" v-if="(item.profile_picture =='' || item.profile_picture ==null) && item.gender == 'Female'" src="../../assets/img/female_default.png">
                        <img @click="showModal(item._id, item.post_id)" v-if="(item.profile_picture =='' || item.profile_picture ==null) && item.gender == 'Male'" src="../../assets/img/male_default.png">
                      </div>
                      <div class="product-info d1">
                        <a class="product-title c-bl" @click="showModal(item._id, item.post_id)">{{item.first_name}} {{item.last_name}}
                          <span class="text-ago pull-right">{{ item.created_at | timeago }}</span></a>
                        <span class="product-description">
                          <span class="text-muted">Position </span>
                          <span class="c-bl"> {{item.designation}}</span>
                          <a @click="acceptRequest(item.post_id, item._id)" style="height: 28px;padding: 5px 10px 5px 10px;" class="b-radious button btn-align sbtn accent-btn rounded raised mt-2 pull-right">Accept</a>
                          <a @click="showReason(item._id, item.post_id)" style="height: 28px;padding: 5px 10px 5px 10px;" class="c-red mt-2 pull-right">Decline</a>
                    </span>
                      </div>
                    </li>
                  <!-- /.item -->
                </ul>
              </div>
              <reason-popup v-model="reasonopen" v-if="reasonopen"></reason-popup>
              <profile-modal v-model="modalOpen" v-if="modalOpen"></profile-modal>
              <!-- /.box-footer -->
            </div>
        </div>
    </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import * as Cookies from 'js-cookie'
import { BaseURL } from '../../shared/classes'
import router from '../../router/index'
// import addpost from '../Feature/addpost_dashboard'
import ProfileModal from '../Feature/profileDetails'
// import AddShedule from '../Feature/addshedule'
import Loading from 'vue-loading-overlay'
// Import stylesheet
// import ViewResult from '../Feature/result_popup'
import ReasonPopup from '../Feature/reasonpopup'
import Vue from 'vue'
import moment from 'moment'
import 'vue-loading-overlay/dist/vue-loading.css'
import { Carousel, Slide } from 'vue-carousel'
Vue.use(moment)
export default {
  name: 'dashboard',
  data () {
    return {
      postsearch: '',
      postsort: 0,
      datas: [],
      tobedatas: [],
      getshedule: [],
      getresult: [],
      config: [],
      datassShow: 3,
      BaseURL: BaseURL,
      mainurl: '',
      modalOpen: false,
      sheduleOpen: false,
      resultOpen: false,
      isLoading: true,
      fullPage: true,
      reasonopen: false,
      tobedataslength: 0,
      getshedulelength: 0,
      getresultlength: 0,
      total_post: 0,
      recent_post: 0,
      total_interest: 0,
      recent_interest: 0,
      total_schedule: 0,
      recent_schedule: 0,
      total_feedbacks: 0,
      recent_feedbacks: 0,
      upcoming_count: 0,
      recent_interest_data: [],
      recent_interest_data_lendth: 0,
      upcoming_Schedule: [],
      dataslength: 0,
      viewid: [],
      base_urls: BaseURL,
      userInfo: JSON.parse(localStorage.getItem('user__details'))
    }
  },
  components: {
    Loading, Carousel, Slide, ReasonPopup, ProfileModal
  },
  created () {
    this.config = {
      headers: {
        'content-type': 'application/json',
        Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
      }
    }
    this.getPostDatas()
    // this.getToBeSheduleDatas()
    // this.sheduleddata()
    // this.getResultDatas()
    this.getCounts()
    this.getRecentInterest()
    this.getRecentSchedule()
    // this.order()
  },
  mounted () {
    // this.$root.$on('message_from_abc', (arg) => {
    //   this.config = {
    //     headers: {
    //       'content-type': 'application/json',
    //       Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
    //     }
    //   }
    //   this.getRecentInterest()
    // })
  },
  methods: {
    viewprofile () {
    },
    connect (id, sid) {
      Cookies.set('channel', id)
      Cookies.set('sid', sid)
      Cookies.set('type', 1)
      localStorage.setItem('type', 1)
      Cookies.set('baseMode', 'avc')
      Cookies.set('transcode', 'interop')
      Cookies.set('attendeeMode', 'video')
      Cookies.set('videoProfile', '480p_4')
      router.push('/agora/meeting')
    },
    checkingdate (date, end) {
      var currentDate = new Date()
      var scheduledate = moment(date).subtract(5, 'minutes').toDate()
      scheduledate = moment(scheduledate).utc().format('YYYYMMDDHHmm')
      var endtime = moment.utc(end).format('YYYYMMDDHHmm')
      var currentdate = moment(String(currentDate)).format('YYYYMMDDHHmm')
      if (currentdate >= scheduledate && currentdate < endtime) {
        return 'yes'
      } else {
        return 'no'
      }
    },
    showReason (id, postid) {
      this.viewid = id
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(postid))
      localStorage.setItem('reschedule', JSON.stringify('interest'))
      this.reasonopen = true
    },
    showModal (id, postid) {
      this.viewid = id
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(postid))
      this.modalOpen = true
    },
    openresult (id, postid, sid) {
      this.viewid = id
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(postid))
      localStorage.setItem('sid', JSON.stringify(sid))
      this.resultOpen = true
    },
    showShedule (id, postid) {
      this.viewid = id
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(postid))
      this.sheduleOpen = true
    },
    getCounts () {
      this.mainurl = '/dashboard/get_dashboard_wizard_count/' + this.userInfo._id
      axios.get(`${this.BaseURL}${this.mainurl}`, this.config).then(response => {
        this.total_post = response.data.organisation_post_count[0].total_post_count
        this.recent_post = response.data.organisation_post_count[0].recent_post_count
        this.total_interest = response.data.post_interest_count[0].post_interest
        this.recent_interest = response.data.recent_interest_count[0].recent_interest_count
        this.total_schedule = response.data.org_schedule_count[0].total_schedule_count
        this.recent_schedule = response.data.org_schedule_count[0].recent_schedule_count
        this.total_feedbacks = response.data.org_feed_back_count[0].total_feedback_count
        this.recent_feedbacks = response.data.org_feed_back_count[0].recent_feedback_count
        this.isLoading = false
      }).catch(e => {
        console.log(e)
      })
    },
    getRecentInterest () {
      this.mainurl = '/dashboard/get_recent_interest_details/' + this.userInfo._id
      axios.get(`${this.BaseURL}${this.mainurl}`, this.config).then(response => {
        this.recent_interest_data = response.data.Recent_interest_details
        this.recent_interest_data_lendth = response.data.Recent_interest_details.length
        this.isLoading = false
      }).catch(e => {
        console.log(e)
      })
    },
    getRecentSchedule () {
      this.mainurl = '/dashboard/get_upcoming_interview_Session/' + this.userInfo._id
      axios.get(`${this.BaseURL}${this.mainurl}`, this.config).then(response => {
        if (response.data.upcoming_interview_Session) {
          this.upcoming_Schedule = response.data.upcoming_interview_Session[0]
          this.upcoming_count = response.data.upcoming_interview_Session.length
        }
        this.isLoading = false
      }).catch(e => {
        console.log(e)
      })
    },
    getPostDatas () {
      var email = this.userInfo.user_email
      var sp = email.split('@')
      if (sp[1] === 'acsicorp.com') {
        this.mainurl = '/dashboard/get_interviewer_list_acs/web/' + "''" + '/' + this.postsort + '/' + this.userInfo._id
      } else {
        this.mainurl = '/dashboard/get_interviewer_list/web/' + "''" + '/' + this.postsort + '/' + this.userInfo._id
      }
      axios.get(`${this.BaseURL}${this.mainurl}`, this.config).then(response => {
        this.datas = response.data.interviewerList
        this.dataslength = response.data.interviewerList.length
        this.isLoading = false
      }).catch(e => {
        console.log(e)
      })
    },
    getToBeSheduleDatas () {
      this.mainurl = '/dashboard/get_tobe_schedule_list_dashboard/web/' + this.userInfo._id
      axios.get(`${this.BaseURL}${this.mainurl}`, this.config).then(response => {
        this.tobedatas = response.data.postDetails
        this.tobedataslength = response.data.postDetails.length
      }).catch(e => {
        console.log(e)
      })
    },
    sheduleddata () {
      this.mainurl = '/dashboard/get_dashboard_schedule_list/web/' + this.userInfo._id
      axios.get(`${this.BaseURL}${this.mainurl}`, this.config).then(response => {
        this.getshedule = response.data.postDetails
        this.getshedulelength = response.data.postDetails.length
      }).catch(e => {
        console.log(e)
      })
    },
    getResultDatas () {
      this.mainurl = '/dashboard/get_dashboard_result_user_list/web/' + this.userInfo._id
      axios.get(`${this.BaseURL}${this.mainurl}`, this.config).then(response => {
        this.getresult = response.data.postDetails
        this.getresultlength = response.data.postDetails.length
        this.isLoading = false
      }).catch(e => {
        console.log(e)
      })
    },
    acceptRequest (postid, userid) {
      const optionsOverrides = {
        durations: {
          global: 3000
        },
        labels: {
          success: '',
          warning: ''
        },
        position: 'bottom-right'
      }
      this.postdatas = []
      const mainurl = '/dashboard/add_org_interest/web'
      this.postdatas = {
        post_id: postid,
        user_id: userid,
        org_id: this.userInfo._id
      }
      this.isLoading = true
      axios.post(`${this.base_urls}${mainurl}`, { formData: this.postdatas }, this.config).then(response => {
        this.isLoading = false
        this.$awn.success('Accepted Successfully', optionsOverrides)
        this.getRecentInterest()
        this.getCounts()
      }).catch(e => {
        console.log(e)
      })
    },
    navigation (tabs, id) {
      localStorage.setItem('postId', JSON.stringify(id))
      router.push({ name: tabs })
    }
  }
}
</script>
<style scoped>
a {
    color: #333;
}
.product-list-in-box>.item:last-of-type {
  border-bottom-width: 1px;
}
.result {
  border: 1px solid #5bad2b !important;
  color: #5bad2b !important;
  margin-top: 6px;
}
.result-status-p {
  background-color: #F5F5F5;
  color: #60AB2F;
  padding: 3px 7px 4px 6px;
}
.result-status-c {
  background-color: red;
  color: #fff;
  padding: 3px 7px 4px 6px;
}
.post-empty {
  width: auto !important;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid #5F2AF2;
  color: #5F2AF2;
  background-color: #fff;
  border-radius: 7px !important;
}
.vall {
  font-weight: 600;
}

.box-body {
  padding: 0px !important;
  height: 231px;
}
.box-title {
  font-size: 16px;
}
.card {
  background-color: white;
  border-radius: 9px;
}
.c-orange {
  color:orange;
}
.product-img img {
    border-radius: 50%;
}
.d1 {
    margin-bottom: 5px !important;
}
.fw-600 {
    font-weight: 600;
}
.fw-500 {
    font-weight: 500;
}
.bottom-count {
    background-color: #FAFAFA;
    padding: 7px 2px;
}
.products-list > .item {
    padding: 5px 10px !important;
}
.product-list-in-box>.item:last-of-type {
    border-bottom-width: 1px;
}
.box-title {
  font-size: 16px;
}
.removeline:focus {
  outline: none !important;
}
.fa-2x {
  font-size: 2rem !important;
}
</style>
